import { RootState } from './../../store/reducers';

export const userSelector = (state: RootState) => state.user;
